import React from 'react';

import CheckboxFilter from 'bundles/backoffice/filters/checkbox';

import type { Features } from 'bundles/apex/activities/types';
import type { Filters } from './types';
import { FormLabel } from 'react-bootstrap-5';

export const options = [
  { label: 'Contact', value: 'Backoffice::Contact' },
  { label: 'Deal', value: 'Apex::Deal' },
  { label: 'Listing', value: 'Project' },
  { label: 'Property', value: 'Research::Property' },
];

type Slice = Pick<Filters, 'parentTypes'>;
interface Props extends Slice {
  features?: Features;
  onChange: (changes: Slice) => void;
}

export default function ParentTypeFilter({ features, parentTypes, onChange }: Props) {
  const filteredOptions = features?.marketingListings
    ? options
    : options.filter(opt => opt.value !== 'Project');

  const getInputText = () => {
    const selected = parentTypes?.map((type) => {
      const matchType = filteredOptions.find(opt => opt.value === type);
      return matchType?.label || '';
    }) || [];

    if (selected.length === filteredOptions.length || selected.length === 0) {
      return 'All Sources';
    } else if (selected.length === 1) {
      return selected[0];
    } else if (selected.length > 1) {
      return `${selected[0]}, +${selected.length - 1}`;
    }
  };

  return (
    <div className="flex-grow-1">
      <FormLabel>Source</FormLabel>
      <CheckboxFilter
        addFilter={(_name, filter) => onChange({ parentTypes: [...parentTypes, filter] })}
        className="text-truncate"
        hideSelectedCount={!parentTypes.length}
        label={getInputText()}
        options={filteredOptions}
        removeFilter={(_name, filter) => onChange({ parentTypes: parentTypes.filter(t => t !== filter) })}
        selected={parentTypes}
      />
    </div>
  );
}
